import { useBackend } from "../../services";
import { IDiscogsAccessRequest } from "./interfaces";

export const useGrantDiscogsAccess = () => {
  const { post } = useBackend();
  return async (parameters: IDiscogsAccessRequest) => {
    return await post("discogs/token", parameters);
  };
};
